import { FUEL_CARD_AND_EXPENSES_FLAG } from '~/common/models/featureFlags.model';

import { PARTNER_DEFAULTS } from '../defaults';
import { ENROLLMENT_VIEWS, PARTNER_IDS, type PartnerConfig } from '../types';
import CoastConnectStep from './CoastConnectStep';
import CoastVehicleStep from './vehicleSelection/CoastVehicleStep';

export const coastConfig: PartnerConfig = {
  id: PARTNER_IDS.COAST,
  providerCode: 'COAST',
  flag: FUEL_CARD_AND_EXPENSES_FLAG,
  nameKey: 'integrations:coast.name',
  shortNameKey: 'integrations:account.coastName',
  descriptionKey: 'integrations:coast.description',
  shop: {
    ...PARTNER_DEFAULTS.shop,
    counts: [
      {
        key: ENROLLMENT_VIEWS.ELIGIBLE,
        labelKey: 'integrations:coast.eligibleToEnroll',
        tooltipKey: 'integrations:coast.eligibilityTooltip',
      },
      {
        key: ENROLLMENT_VIEWS.ENROLLED,
        labelKey: 'integrations:coast.enrolled',
      },
    ],
  },
  manage: {
    ...PARTNER_DEFAULTS.manage,
    unlinkConfirmBodyKey: 'integrations:coast.unlinkConfirmBody',
  },
  wizard: {
    titleKey: 'integrations:coast.wizardTitle',
    steps: [
      {
        id: 'confirmAccount',
        labelKey: 'integrations:coast.connectFuelCard',
        component: CoastConnectStep,
      },
      {
        id: 'selectVehicles',
        labelKey: 'integrations:coast.enrollVehicles',
        component: CoastVehicleStep,
      },
    ],
  },
};
